// extracted by mini-css-extract-plugin
module.exports = {"layout":"FacebookPlugin_layout__3pXK3"};